<script>
  import { _ } from 'svelte-i18n';
  import { createEventDispatcher } from 'svelte';
  import SearchBox from '../SearchBox.svelte';

  let searchBox;
  export let layer;
  export function reset() {
    searchBox?.reset();
  }

  const dispatch = createEventDispatcher();

  function selectFeature(item) {
    dispatch('selectFeature', {
      feature: !item
        ? null
        : layer?.features.find((f) => f.properties.id === item.key)
    });
  }

  $: searchItems = layer?.features.map((feature) => ({
    key: feature.properties.id,
    title: feature.properties.name,
    subtitle: feature.properties.code || null
  }));
</script>

<SearchBox
  bind:this={searchBox}
  items={searchItems}
  placeholder={$_('dashboard.vaccinationsRegions.search.placeholder')}
  on:selectItem={(e) => selectFeature(e.detail.item)}
  on:cancel={() => {
    selectFeature(null);
    dispatch('clearSelection');
  }}
/>
